import { apiService } from '..';

const THROTTLE_MS = 60_000;

let lastFetchTime = 0;
let cachedMessage = '';
let inflight: Promise<string> | null = null;

export const getBannerMessage = (): Promise<string> => {
  if (inflight) return inflight;
  if (Date.now() - lastFetchTime < THROTTLE_MS)
    return Promise.resolve(cachedMessage);

  inflight = apiService
    .get<{ message: string }>({ path: 'api/v1/ui-config/banner-message' })
    .then((response) => {
      cachedMessage = response.data?.message || '';
      lastFetchTime = Date.now();
      return cachedMessage;
    })
    .catch(() => '')
    .finally(() => {
      inflight = null;
    });

  return inflight;
};
